<template>
  

    <div class="ItemTreeSEDetailsObject" >
        
      <li v-for="(item,index) in Object.keys(model)" :key="index">
        
            
        <span v-if="checkSimilar(model, item) == true">                  
          <div class="treeline" >
              
                  <img class="expandimage" v-show="openArray[index].open == false" v-if="(typeof model[item]) !== 'string' && (model[item] !== null)" @click="toggle(index)" src="/static/branch-collapsed.png">


                  <img class="expandimage"  v-show="openArray[index].open == true" v-if="(typeof model[item]) !== 'string' && (model[item] !== null)" @click="toggle(index)" src="/static/branch-expanded-dark.png">
                  
                  <img class="expandimage" v-if="(typeof model[item]) == 'string' && (typeof model[item]) == null" src="/static/transparent_icon_24.png">
              <span v-if="isSearch">
                
              </span>
                
              <a class="item__name" @click="toggle(index)">
                
                  <span class="key-item">
                    {{ parentName == '' ? '' : parentName }}
                    <span class="highlighting-item" v-if="item == 'PartNumber' || item == 'ManufacturerPartNumber'" >{{item}}</span>
                    <span class="highlighting-item" v-else-if="item == 'Manufacturer' || item == 'ManufacturerName'" >{{item}}</span>
                    <span v-else>{{item}}</span> 

                  </span>
                  <span class="value-item">
                    <span v-if="typeof model[item] == 'string'" >: 
                      
                      <span v-if="item == 'OverallRisk'"><b-badge :variant="getOverallRisk(model[item])">{{ model[item] }}</b-badge></span>
                      <span v-else-if="item == 'EstimatedYearsToEOL'"><b-badge :variant="getEstimatedYearsToEOL(model[item])">{{ model[item] }}</b-badge></span>
                      <span v-else-if="model[item] != null" v-html="checkIfLink(model[item])"></span>
                      <span v-else>null</span>
                    </span>
                    <span v-if="model[item] == null" >: 
                                                  
                      <span>null</span>
                    </span>
                  
                  </span>
                  
                  
              </a>
              
            
                                            
              
          
          </div>
        </span>
        <ul  v-show="openArray[index].open" v-if="(typeof model[item] !== 'string')" :class="isSearch ? 'item_ul_search' : 'item_ul'" >
          
          <ItemTreeSEDetailsObject 
          
              :parentName="parentName + item + '/'"
              class="item" 
              v-if="!Array.isArray(model[item]) && model[item] != null" 
              :model="model[item]"
              :specialParam="specialParam"
              :searchString="searchString"
            ></ItemTreeSEDetailsObject>
            <ItemTreeSEDetailsArray
              :parentName="parentName + item + '/'"
              class="item" 
              v-if="Array.isArray(model[item]) && model[item] != null" 
              :model="model[item]"
              :specialParam="specialParam"
              :searchString="searchString"
            ></ItemTreeSEDetailsArray>
        </ul>
  

      </li>
    </div>
    
  
</template>

<script>

//import ItemTreeSEDetailsObject from "@/components/shared/ItemTreeSEDetailsObject"
//import ItemTreeSEDetailsArray from "@/components/shared/ItemTreeSEDetailsArray"
import { mapGetters } from 'vuex'

export default {
  name: 'ItemTreeSEDetailsObject',
  components: {
     
      ItemTreeSEDetailsObject: () => import("@/components/shared/ItemTreeSEDetailsObject"),
      ItemTreeSEDetailsArray: () => import("@/components/shared/ItemTreeSEDetailsArray"),
    },
    props: {
      model: Object,
      specialParam: Object,
      searchString: String,
      parentName: String
    },
    data: function () {
        return {
          name: this.model,
          openArray: [],
          visibleElement: false
        };
    },
    computed: {
      ...mapGetters({

      
        globalSettings: "globalSettings",
      
      }),
      uid(){

          return this._uid
      },
      isSearch() {
        return this.searchString.length > 2;
      }
      

    },
    created () {
      this.init();
    },
    watch: {
      searchString: function (newVal) {
            
        
        if (newVal.length > 2) {
          for (let i = 0, len = this.openArray.length; i < len; i++){
            this.openArray[i].open = true;
          }
        } else {
          for (let i = 0, len = this.openArray.length; i < len; i++){
            this.openArray[i].open = false;
            
          }
          this.visibleElement = false;
        }
        

      },

    },
  
    methods: {
      init() {
        this.openArray = [];
        let index = 0;
        for (let item in this.model) {
          
          let obj = {
            item: item,
            open: false,
            index: index
          }
          index++;
          this.openArray.push(obj);
        }
        
        
      },
      setVisible(value) {
        
        this.visibleElement = value;
      },
      setParentVisible() {
        this.$parent.setVisible(this.parentName);
      },
      
      checkSimilar(model, item) {

        if (this.isSearch == false) {

          return true;
        }

        let str = this.searchString.toLowerCase();
        

        if (typeof model[item] == "string") {
          let pos1 = item.toLowerCase().indexOf(str);
          
          if (pos1 > -1) {
            
            this.setParentVisible();
            return true;
          }

          let pos2 = model[item].toLowerCase().indexOf(str);

          if (pos2 > -1) {
            
            this.setParentVisible();
            return true;
          }
        }
        

        return false;
      },
      toggle(index) {
                  
        this.openArray[index].open = !this.openArray[index].open;

      },
      getOverallRisk(item) {
        let variant = "";
        let pos = item.indexOf("%");
        if (pos > -1) {
          let temp = item.split("%");


          if (temp[0] <= this.globalSettings.SERiskRange1) {
            variant = "success";
          } else if (temp[0] > this.globalSettings.SERiskRange2) {
            variant = "danger";
          } else if ((temp[0] > this.globalSettings.SERiskRange1) && (temp[0] <= this.globalSettings.SERiskRange2)) {
            variant = "warning";
          }
          
          if (temp[0] == 0 && this.specialParam.LifecycleRisk == "Unknown") {
                    
            variant = "orange";
          }
        }
        

        

        return variant;
      },
      getEstimatedYearsToEOL(item) {
        
        let variant = "";

        if (item != "") {

          let value = parseFloat(item);
          let range1 = parseFloat(this.globalSettings.SEEOLRange1);
          let range2 = parseFloat(this.globalSettings.SEEOLRange2);
                  
          if (value <= range1) {
            
            variant = "danger";
          } else if (value > range2) {
            
            variant = "success";
          } else if ((value <= range2) && (value > range1)) {
            
            variant = "warning";
          }
          
        }


        return variant;
      },
      checkIfLink(data) {

        let pos1 = data.indexOf("http://");
        let pos2 = data.indexOf("https://");

        if (pos1 > -1 || pos2 > -1) {

          return "<a href=\""+data+"\" target=\"_blank\">" + data + "</a>";
        } else {
          return data;
        }
        
      }
    
    }
  }
</script>


<style lang="scss">

   

  .ItemTreeSEDetailsObject{
    li {
      width: fit-content;
    }
    .expandimage {
      width: 16px;
      height: 16px;
      margin-left: 5px;
      margin-top: 2px;
    }
    .expand__container{
      width:20px;
      height: 15px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      flex-direction: column;
    }
    
    .item_ul {
      padding-left: 18px;
      line-height: 1.1em;
      list-style-type: none;

    }
    .item_ul_search {
      padding-left: 0px;
      line-height: 1.1em;
      list-style-type: none;

    }    
    .item__name{
      cursor: pointer;
      font-size: 0.75rem;
      margin: 2px;
    }
    
    .key-item{
      
      margin-bottom: 3px;
    }
    
    .treeline{
      display: inline-flex;

    }

    a{
      padding-right: 10px;
      padding-left: 10px;
    }

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/ItemTreeSEDetailsObject.vue